import React, { useEffect } from "react";
import { useDoubt } from "../../../context/DoubtContext";
import ChatImg from "../../../assets/ai-tutor/chat.svg";
import Arrow from "../../../assets/ai-tutor/arrow.svg";
import AssistantImg from "../../../assets/ai-tutor/assistant.svg";
import CustomButton from "../../../components/atoms/CustomButton/CustomButton";
import ChatView from "../../../components/molecules/ai-tutor/ChatView/ChatView";
import pkg from "@inrscr/coschool-ui-components";
import assisstantStyles from "../../../components/molecules/ai-tutor/Assistant/assistant.module.css";
import Styles from "./summaryView.module.css";
import { Box } from "@chakra-ui/react";

export default function SummaryView() {
  const {
    selectedSummary,
    retrieveUserChat,
    userChat,
    handleReset,
    assistantRefImages
  } = useDoubt();
  const { TutorSummary } = pkg;
  const { query, summary, chat_uuid } = selectedSummary;

  useEffect(() => {
    handleReset();
    return () => {};
  }, []);
  const formatChatHistory = () => {
    let output = [];
    for (let obj of userChat) {
      // Ensure we only add non-empty user queries and AI responses
      if (obj?.user_query && obj?.ai_assist_answer) {
        let newArr = [
        { role: "user", content: obj.user_query },
        { role: "assistant", content: obj.ai_assist_answer }];

        // Spread the newArr contents into the output array
        output.push(...newArr);
      }
    }
    return output;
  };

  const summary_view = () => {
    return (
      <React.Fragment>
        <TutorSummary
          summaryTitle={"Key Takeaway"}
          summary={summary}
          styles={assisstantStyles}
          icons={{
            Arrow,
            Assistant: AssistantImg
          }}
          assistantRefImages={assistantRefImages}
          isDoubt={true} />

        {/* <div className={styles["row-end"]}>
           <CustomButton
             label={`See Conversation`}
             image={ChatImg}
             handleClick={() => {
               retrieveUserChat(chat_uuid);
             }}
           />
          </div> */}
      </React.Fragment>);

  };
  const conversation_view = () => {
    let formattedHis = formatChatHistory();
    return (
      <React.Fragment>
        {userChat?.length > 0 &&
        <ChatView
          history={formattedHis}
          assistantRefImages={assistantRefImages} />

        }
        <Box position={"relative"} mt={"32px"}>
          <TutorSummary
            summaryTitle={"Key Takeaway"}
            summary={summary}
            styles={assisstantStyles}
            icons={{
              Arrow,
              Assistant: AssistantImg
            }}
            assistantRefImages={assistantRefImages}
            isDoubt={true} />

        </Box>
      </React.Fragment>);

  };
  return (
    <div className={Styles["mainContainer"]}>
      <div className={Styles["subContainer"]}>
        {userChat?.length == 0 && summary_view()}
        {userChat?.length > 0 && conversation_view()}
      </div>
    </div>);

}